import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import { ProtectedRoute } from './sections/auth/ProtectedRoute';
import FinishedJobsPage from './pages/FinishedJobsPage';
import MuhaberatEntryPage from './pages/MuhaberatEntry';
import MuhaberatOutput from './pages/MuhaberatOutput';
import HandsfreePage from './pages/HandsfreePage';
import AllActionsPage from './pages/AllActionsPage';
import StatsPage from './pages/Stats';
import CourierCargo from './pages/CourierCargo';
import EsnafCourierCargo from './pages/EsnafCourierCargo';
import RobotListsPage from './pages/RobotListsPage';
import RobotActionsPage from './pages/RobotActionsPage';
import PriceTablePage from './pages/PriceTablePage';
import TechnicalSupportRequests from './pages/TechnicalSupportRequests';
import FormWithoutLogin from './pages/FormWithoutLogin';
import CreateEmployeeApproval from './pages/CreateEmployeeApproval';
import PostDetailPage from './pages/PostDetailPage';
import PointsPage from './pages/PointsPage';
import PointsBulkEditPage from './pages/PointsBulkEditPage';
import Checkroom from './pages/CheckRoom';
import PriceCabineTable from './pages/PriceCabineTable';
import ProfilePage from './pages/ProfilePage';
import SupportTickets from './pages/SupportTickets';
import UpdateReports from './pages/UpdateReports';
import NotificationManagement from './pages/NotificationManagement';
import HakedisReport from './pages/HakedisReport';
import HakedisManagementPage from './pages/HakedisManagementPage';
import HakedisManagementDetailPage from './pages/HakedisManagementDetailPage';
import PointsMapPage from './pages/PointsMapPage';
import EditUserForPoint from './pages/EditUserForPoint';
import AvmList from './pages/AvmList';
import FastReport from './pages/FastReport';
import CreateReport from './pages/CreateReport';
import SendPanic from './pages/SendPanic';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import BolPara from './pages/BolPara';
import BolParaApplications from './pages/BolParaApplications';
import CampaignPage from './pages/CampaignPage';
import CreateForm from './pages/CreateForm';
import CargoPartnerOperations from './pages/CargoPartners/CargoPartnerOperations';
import CargoPartnerReceivePage from './pages/CargoPartners/CargoPartnerReceivePage';
import CargoPartnersRefund from './pages/CargoPartners/CargoPartnersRefund';
import CargoPartnerTakeOrderPage from './pages/CargoPartners/CargoPartnerTakeOrderPage';
import CargoPartnersGivingBackPage from './pages/CargoPartners/CargoPartnersGivingBackPage';
import CargoPartnerLeaveRequest from './pages/CargoPartners/CargoPartnerLeaveRequest';
import CargoPartnerOrderCreation from './pages/CargoPartners/CargoPartnerOrderCreation';
import DHLShipments from './pages/CargoPartners/DHLShipments';
import LockerTrackSystem from './pages/LockerTrackSystem';
import SurveySolutions from './pages/SurveySolutions';
import SurveyResponses from './pages/SurveyResponses';
import EpAppPosts from './pages/EpAppPosts';
import LockerTrackingSystem from './pages/LockerTrackingSystem';
import LogSearch from './pages/LogSearch';
import BolParaRequestManagementPage from './pages/BolParaRequestManagementPage';
import FastReportList from './pages/FastReportList';
import CheckroomOperations from './pages/CheckroomOperations';
import KidVehicles from './pages/KidVehicles';
import PetVehicles from './pages/PetVehicles';
import CargoPartnerTakeEcommerce from './pages/CargoPartners/CargoPartnerTakeEcommerce';
import EsnafTutorialPage from './pages/EsnafTutorialPage';
import FaqPage from './pages/FaqPage';
import FaqManagementPage from './pages/FaqManagementPage';
import BolParaEsnafMain from './pages/BolParaEsnaf/BolParaEsnafMain';
import BolParaEsnafApplications from './pages/BolParaEsnaf/BolParaEsnafApplications';
import { BolparaEsnafCompanyCampaigns } from './pages/BolParaEsnaf/BolparaEsnafCompanyCampaigns';
import BolParaEsnafPackageInfo from './pages/BolParaEsnaf/BolParaEsnafPackageInfo';
import BolparaTutorialPage from './pages/BolParaTutorialPage';
import EmanetReportPage from './pages/EmanetReportPage';
import CargoPartnerTakeDropOff from './pages/CargoPartners/CargoPartnerTakeDropOff';
import GiftPackages from './pages/GiftPackages';
import DHLSendSign from './pages/DHLSendSign';
import EasyPointServices from './pages/EasyPointServices';
import CouponsPage from './pages/CouponsPage';
import EasyPointServicesReport from './pages/EasyPointServicesReport';
import EPBulkServiceManagement from './pages/EPBulkServiceManagement';
import FormRenderer from './modals/FormRenderer';
import BoxOperationsPage from './pages/BoxOperations/BoxOperationsPage';
import BoxDetailsPage from './pages/BoxOperations/BoxDetailPage';
import BoxStatusPage from './pages/BoxOperations/BoxStatusPage';
import BoxOperationsSendingSMS from './pages/BoxOperations/BoxOperationsSendingSMS';
import BoxOperationsCouponPage from './pages/BoxOperations/BoxOperationsCouponPage';
import CampaignFormApplications from './pages/CampaignFormApplications';
import UserTutorialPage from './pages/UserTutorialPage';
import OrderReportPage from './pages/OrderReportPage';
import ContactFormsPage from './pages/ContactForms';
import EPServiceManagement from './pages/EPServiceManagement';
import CDEKOperations from './pages/CDEKOperations';
import { tokenService } from './services';
import { canAccessDHLShipments, canAccessProgressPayment, canAccessEPServiceManagement } from './utils/accessControl';
import HandsFreeOperations from './pages/HandsFreeOperations';
// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        {
          path: 'app',
          element: (
            <ProtectedRoute>
              <DashboardAppPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'post-details/:id',
          element: (
            <ProtectedRoute>
              <PostDetailPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'finished-jobs',
          element: (
            <ProtectedRoute>
              <FinishedJobsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'users',
          element: (
            <ProtectedRoute>
              <UserPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'points',
          element: (
            <ProtectedRoute>
              <PointsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'points-bulk-edit',
          element: (
            <ProtectedRoute>
              <PointsBulkEditPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'edit-point-user/:id',
          element: (
            <ProtectedRoute>
              <EditUserForPoint />
            </ProtectedRoute>
          ),
        },
        {
          path: 'monthly-cabine',
          element: (
            <ProtectedRoute>
              <PriceCabineTable />
            </ProtectedRoute>
          ),
        },
        {
          path: 'checkroom',
          element: (
            <ProtectedRoute>
              <Checkroom />
            </ProtectedRoute>
          ),
        },
        {
          path: 'muhaberat-entry',
          element: (
            <ProtectedRoute>
              <MuhaberatEntryPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'muhaberat-output',
          element: (
            <ProtectedRoute>
              <MuhaberatOutput />
            </ProtectedRoute>
          ),
        },
        {
          path: 'handsfree',
          element: (
            <ProtectedRoute>
              <HandsfreePage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'easypoint-services',
          element: (
            <ProtectedRoute>
              <EasyPointServices />
            </ProtectedRoute>
          ),
        },
        {
          path: 'coupons',
          element: (
            <ProtectedRoute>
              <CouponsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'services-report',
          element: (
            <ProtectedRoute>
              <EasyPointServicesReport />
            </ProtectedRoute>
          ),
        },
        {
          path: 'easypoint-service-management',
          element: (
            <ProtectedRoute
              isAllowed={canAccessEPServiceManagement(tokenService.getUser())}
            >
              <EPServiceManagement />
            </ProtectedRoute>
          ),
        },
        {
          path: 'ep-bulk-service-management',
          element: (
            <ProtectedRoute
              isAllowed={canAccessEPServiceManagement(tokenService.getUser())}
            >
              <EPBulkServiceManagement />
            </ProtectedRoute>
          ),
        },
        {
          path: 'all-posts',
          element: (
            <ProtectedRoute>
              <AllActionsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'stats',
          element: (
            <ProtectedRoute>
              <StatsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'box-operations',
          element: (
            <ProtectedRoute>
              <BoxOperationsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'box-details',
          element: (
            <ProtectedRoute>
              <BoxDetailsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'box-status',
          element: (
            <ProtectedRoute>
              <BoxStatusPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'box-sending-sms',
          element: (
            <ProtectedRoute>
              <BoxOperationsSendingSMS />
            </ProtectedRoute>
          ),
        },
        {
          path: 'box-operations-coupons',
          element: (
            <ProtectedRoute>
              <BoxOperationsCouponPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'courier-cargo',
          element: (
            <ProtectedRoute>
              <CourierCargo />
            </ProtectedRoute>
          ),
        },
        {
          path: 'courier-cargo/esnaf/',
          element: (
            <ProtectedRoute>
              <EsnafCourierCargo />
            </ProtectedRoute>
          ),
        },
        {
          path: 'courier-cargo-order-report/',
          element: (
            <ProtectedRoute>
              <OrderReportPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cdek-operations',
          element: (
            <ProtectedRoute>
              <CDEKOperations />
            </ProtectedRoute>
          ),
        },
        {
          path: 'robot-lists',
          element: (
            <ProtectedRoute>
              <RobotListsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'robot-actions',
          element: (
            <ProtectedRoute>
              <RobotActionsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'monthly-prices',
          element: (
            <ProtectedRoute>
              <PriceTablePage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'technical-support-requests',
          element: (
            <ProtectedRoute>
              <TechnicalSupportRequests />
            </ProtectedRoute>
          ),
        },
        {
          path: 'create-employee-approval',
          element: (
            <ProtectedRoute>
              <CreateEmployeeApproval />
            </ProtectedRoute>
          ),
        },
        {
          path: 'profile',
          element: (
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'support-tickets',
          element: (
            <ProtectedRoute>
              <SupportTickets />
            </ProtectedRoute>
          ),
        },
        {
          path: 'support-tickets/:id',
          element: (
            <ProtectedRoute>
              <SupportTickets />
            </ProtectedRoute>
          ),
        },
        {
          path: 'support-tickets/complete/:id',
          element: (
            <ProtectedRoute>
              <SupportTickets />
            </ProtectedRoute>
          ),
        },
        {
          path: 'update-reports',
          element: (
            <ProtectedRoute>
              <UpdateReports />
            </ProtectedRoute>
          ),
        },
        {
          path: 'notification-management',
          element: (
            <ProtectedRoute>
              <NotificationManagement />
            </ProtectedRoute>
          ),
        },
        {
          path: 'hakedis-management',
          element: (
            <ProtectedRoute isAllowed={canAccessProgressPayment(tokenService.getUser())}>
              <HakedisManagementPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'hakedis-management/:id',
          element: (
            <ProtectedRoute isAllowed={canAccessProgressPayment(tokenService.getUser())}>
              <HakedisManagementDetailPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'earn-report',
          element: (
            <ProtectedRoute>
              <HakedisReport />
            </ProtectedRoute>
          ),
        },
        {
          path: 'update-reports/:id',
          element: (
            <ProtectedRoute>
              <UpdateReports />
            </ProtectedRoute>
          ),
        },
        {
          path: 'bol-para',
          element: (
            <ProtectedRoute>
              <BolPara />
            </ProtectedRoute>
          ),
        },
        {
          path: 'bol-para-applications',
          element: (
            <ProtectedRoute>
              <BolParaApplications />
            </ProtectedRoute>
          ),
        },
        {
          path: 'bol-para-esnaf',
          element: (
            <ProtectedRoute>
              <BolParaEsnafMain />
            </ProtectedRoute>
          ),
        },
        {
          path: 'bol-para-esnaf-applications',
          element: (
            <ProtectedRoute>
              <BolParaEsnafApplications />
            </ProtectedRoute>
          ),
        },
        {
          path: 'bol-para-esnaf/:companyID',
          element: (
            <ProtectedRoute>
              <BolparaEsnafCompanyCampaigns />
            </ProtectedRoute>
          ),
        },
        {
          path: 'bol-para-esnaf/:companyID/:campaignID',
          element: (
            <ProtectedRoute>
              <BolParaEsnafPackageInfo />
            </ProtectedRoute>
          ),
        },
        {
          path: 'mall-list',
          element: (
            <ProtectedRoute>
              <AvmList />
            </ProtectedRoute>
          ),
        },
        {
          path: 'fast-report',
          element: (
            <ProtectedRoute>
              <FastReport />
            </ProtectedRoute>
          ),
        },
        {
          path: 'fast-report-list',
          element: (
            <ProtectedRoute>
              <FastReportList />
            </ProtectedRoute>
          ),
        },
        {
          path: 'create-report',
          element: (
            <ProtectedRoute>
              <CreateReport />
            </ProtectedRoute>
          ),
        },
        {
          path: 'send-panic',
          element: (
            <ProtectedRoute>
              <SendPanic />
            </ProtectedRoute>
          ),
        },
        {
          path: 'campaign',
          element: (
            <ProtectedRoute>
              <CampaignPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'campaign-applications',
          element: (
            <ProtectedRoute>
              <CampaignFormApplications />
            </ProtectedRoute>
          ),
        },
        {
          path: 'create-form',
          element: (
            <ProtectedRoute>
              <CreateForm />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-partner-operations',
          element: (
            <ProtectedRoute>
              <CargoPartnerOperations />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-partner-operations/receive/:partner',
          element: (
            <ProtectedRoute>
              <CargoPartnerReceivePage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-partner-operations/ecommerce-refund/:partner',
          element: (
            <ProtectedRoute>
              <CargoPartnersRefund />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-partner-operations/take-order/:partner',
          element: (
            <ProtectedRoute>
              <CargoPartnerTakeOrderPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-partner-operations/giving-back/:partner',
          element: (
            <ProtectedRoute>
              <CargoPartnersGivingBackPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-partner-operations/take-ecommerce/:partner',
          element: (
            <ProtectedRoute>
              <CargoPartnerTakeEcommerce />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-partner-operations/take-dropoff/:partner',
          element: (
            <ProtectedRoute>
              <CargoPartnerTakeDropOff />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-partner-operations/request/:partner',
          element: (
            <ProtectedRoute>
              <CargoPartnerLeaveRequest />
            </ProtectedRoute>
          ),
        },
        {
          path: 'cargo-partner-operations/order-creation/:partner',
          element: (
            <ProtectedRoute>
              <CargoPartnerOrderCreation />
            </ProtectedRoute>
          ),
        },
        {
          path: 'dhl-shipments',
          element: (
            <ProtectedRoute isAllowed={canAccessDHLShipments(tokenService.getUser())}>
              <DHLShipments />
            </ProtectedRoute>
          ),
        },
        {
          path: 'hands-free',
          element: (
            <ProtectedRoute>
              <HandsFreeOperations />
            </ProtectedRoute>
          ),
        },
        {
          path: 'locker-track-system',
          element: (
            <ProtectedRoute>
              <LockerTrackSystem />
            </ProtectedRoute>
          ),
        },
        {
          path: 'locker-tracking-system',
          element: (
            <ProtectedRoute>
              <LockerTrackingSystem />
            </ProtectedRoute>
          ),
        },
        {
          path: 'survey-responses/:id',
          element: (
            <ProtectedRoute>
              <SurveyResponses />
            </ProtectedRoute>
          ),
        },
        {
          path: 'ep-app-posts',
          element: (
            <ProtectedRoute>
              <EpAppPosts />
            </ProtectedRoute>
          ),
        },
        {
          path: 'log-search',
          element: (
            <ProtectedRoute>
              <LogSearch />
            </ProtectedRoute>
          ),
        },
        {
          path: 'bol-para-request-management',
          element: (
            <ProtectedRoute>
              <BolParaRequestManagementPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'checkroom-operations',
          element: (
            <ProtectedRoute>
              <CheckroomOperations />
            </ProtectedRoute>
          ),
        },
        {
          path: 'kid-vehicles',
          element: (
            <ProtectedRoute>
              <KidVehicles />
            </ProtectedRoute>
          ),
        },
        {
          path: 'pet-vehicles',
          element: (
            <ProtectedRoute>
              <PetVehicles />
            </ProtectedRoute>
          ),
        },
        {
          path: 'gift-packages',
          element: (
            <ProtectedRoute>
              <GiftPackages />
            </ProtectedRoute>
          ),
        },
        {
          path: 'esnaf-tutorial',
          element: (
            <ProtectedRoute>
              <EsnafTutorialPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'bolpara-tutorial',
          element: (
            <ProtectedRoute>
              <BolparaTutorialPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'user-tutorial',
          element: (
            <ProtectedRoute>
              <UserTutorialPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'faq',
          element: (
            <ProtectedRoute>
              <FaqPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'faq-management',
          element: (
            <ProtectedRoute>
              <FaqManagementPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'emanet-report',
          element: (
            <ProtectedRoute>
              <EmanetReportPage />
            </ProtectedRoute>
          ),
        },
        {
          path: 'contact-forms',
          element: <ContactFormsPage />,
        },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'forgot-password',
      element: <ForgotPasswordPage />,
    },
    /*
    {
      path: 'form-without-login',
      element: <FormWithoutLogin />,
    },
    */
    {
      path: 'points-map',
      element: <PointsMapPage />,
    },
    {
      path: 'survey/:id',
      element: <SurveySolutions />,
    },
    {
      path: '/dhl-send-sign',
      element: <DHLSendSign />,
    },
    {
      path: '/dhl-send-sign/:barcode',
      element: <DHLSendSign />,
    },
    {
      path: '/form-renderer/:campaignID/:formID',
      element: <FormRenderer />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
